/*global google*/

import React from "react";
import ReactDOM from "react-dom";
import { compose, withProps, lifecycle } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Polygon
} from "react-google-maps";
import { DrawingManager } from "react-google-maps/lib/components/drawing/DrawingManager";
import { SearchBox } from 'react-google-maps/lib/components/places/SearchBox';

import _ from 'lodash';

const MapWithADrawingManager = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBm1lrZTw4r-6Z3pkFKfPPs7NHz_RGHg6Y&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  lifecycle({
    componentWillMount() {
      const refs = {}

      this.setState({
        bounds: null,
        center: {
          lat: 49.7437572, lng: 15.3386383
        },
        zoom: 7,
        markers: [],
        onMapMounted: ref => {
          refs.map = ref;
        },
        onSearchBoxMounted: ref => {
          refs.searchBox = ref;
        },
        onPlacesChanged: () => {
          const places = refs.searchBox.getPlaces();
          const bounds = new google.maps.LatLngBounds();

          places.forEach(place => {
            if (place.geometry.viewport) {
              bounds.union(place.geometry.viewport)
            } else {
              bounds.extend(place.geometry.location)
            }
          });
          const nextMarkers = places.map(place => ({
            position: place.geometry.location,
          }));
          const nextCenter = _.get(nextMarkers, '0.position', this.state.center);

          this.setState({
            center: nextCenter,
            markers: nextMarkers,
            zoom: 16,
          });
        },
      })
    },
  }),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap
    ref={props.onMapMounted}
    zoom={props.zoom}
    center={props.center} >    
    <SearchBox
      ref={props.onSearchBoxMounted}
      bounds={props.bounds}
      controlPosition={google.maps.ControlPosition.BOTTOM_CENTER}
      onPlacesChanged={props.onPlacesChanged} >
      <div>
        <input
          type="text"
          placeholder="Hledat..."
          style={{
            boxSizing: `border-box`,
            border: `1px solid transparent`,
            width: `350px`,
            height: `32px`,
            padding: '5px 5px 5px 5px',
            marginBottom: `25px`,
            borderRadius: `3px`,
            boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
            fontSize: `14px`,
            outline: `none`,
            textOverflow: `ellipses`,
          }} />
        <button style={{
              background: 'white',              
              marginLeft: 20,
              borderRadius: '3px',
              padding: 7,
              position: 'relative',
              cursor: 'pointer',             
              height: 32,
              top: 0,
              left: 0          
        }}>Remove all</button>
      </div>
    </SearchBox>
    <DrawingManager
      defaultDrawingMode={google.maps.drawing.OverlayType.POLYGON}
      onPolygonComplete={polygon => {
        var coords = [];
        polygon
          .getPath()
          .getArray()
          .map(c => {
            coords.push({
              Y: c.lat(),
              X: c.lng()
            });
          });
        props.onPolygonChanged != undefined
          ? props.onPolygonChanged(coords)
          : null;

        polygon.getPaths().forEach((path, index) => {
          google.maps.event.addListener(path, "insert_at", () => {
            coords = [];
            polygon
              .getPath()
              .getArray()
              .map(c => {
                coords.push({
                  Y: c.lat(),
                  X: c.lng()
                });
              });
            props.onPolygonChanged != undefined
              ? props.onPolygonChanged(coords)
              : null;
          });

          google.maps.event.addListener(path, "remove_at", () => {
            coords = [];
            polygon
              .getPath()
              .getArray()
              .map(c => {
                coords.push({
                  Y: c.lat(),
                  X: c.lng()
                });
              });
            props.onPolygonChanged != undefined
              ? props.onPolygonChanged(coords)
              : null;
          });

          google.maps.event.addListener(path, "set_at", () => {
            coords = [];
            polygon
              .getPath()
              .getArray()
              .map(c => {
                coords.push({
                  Y: c.lat(),
                  X: c.lng()
                });
              });
            props.onPolygonChanged != undefined
              ? props.onPolygonChanged(coords)
              : null;
          });
        });
      }}
      onMarkerComplete={(marker) => {
        props.onMarkerChanged != undefined
          ? props.onMarkerChanged({
            Y: marker.getPosition().lat(),
            X: marker.getPosition().lng()
          })
          : null;

        google.maps.event.addListener(marker, 'dragend', (mmarker) => {
          props.onMarkerChanged != undefined
            ? props.onMarkerChanged({
              Y: mmarker.latLng.lat(),
              X: mmarker.latLng.lng()
            })
            : null;
        });
      }}
      defaultOptions={{
        drawingMode: null,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [
            google.maps.drawing.OverlayType.MARKER,
            google.maps.drawing.OverlayType.POLYGON,
          ]
        },
        polygonOptions: {
          draggable: false,
          editable: true
        },
        markerOptions: {
          draggable: true
        }
      }} />
      {props.polygonPath 
        ? <Polygon
            draggable={false}
            editable={true}
            path={props.polygonPath} /> 
        : null}
  </GoogleMap>
));

export default MapWithADrawingManager;



// WEBPACK FOOTER //
// ./src/components/MapWithDrawingManager.js